/* eslint-disable camelcase */
import { sendAnalyticsPayload, utagAnalyticsBaseAttributes, UtagAnalyticsType } from '@garmin/analytics';

const eventDataExists = (payload = {}) => {
  if (Array.isArray(payload)) return payload.length > 2;
  if (typeof payload === 'object') return Object.keys(payload)?.length > 2;
  return false;
};

/**
 *
 * @param {object | Array | string} eventPayload ->
 * ** Example String: 'category,action,label, product_name?, page_type?, link_type?'
 * ** Example Array: [category, action, label, product_name?, page_type?, link_type?]
 * ** Example Object: {event_category: 'category', event_action: 'action', event_label: 'label'}
 * @param {string} separator Optional. Defaults to comma separated for string payload argument
 * @returns {object} Returns event object in proper format for tracking.
 * link_type and page_type will be set to the values
 *  of event_action and event_cateogry unless overridden
 */
const transformEventPayload = (eventPayload, separator = ',') => {
  let p = eventPayload || {};
  if (typeof p === 'string') p = p.split(separator);
  if (!eventDataExists(p)) return {};

  if (Array.isArray(p)) {
    const [event_category, event_action, event_label, ...rest] = p;
    const product_name = rest?.[0];
    const page_type = rest?.[1] || event_category;
    const link_type = rest?.[2] || event_action;

    p = {
      event_category,
      event_action,
      event_label,
      page_type,
      link_type,
      ...(product_name && { product_name }),
    };
  } else {
    if (p.event_category) p.page_type = p.page_type || p.event_category;
    if (p.event_action) p.link_type = p.link_type || p.event_action;
  }

  return Object.fromEntries(
    Object.entries(p).map(([key, value]) => [key, value ? value.toString().trim() : null]),
  );
};

export const fireUtagEvent = (payload, sep) => {
  const trackerPayload = transformEventPayload(payload, sep);
  utagAnalyticsBaseAttributes[UtagAnalyticsType.LINK] = {
    tealium_event: 'ps_generic_event',
    page_name: document?.title,
  };

  // eslint-disable-next-line max-len
  if (Object.keys(trackerPayload).length) sendAnalyticsPayload(trackerPayload, UtagAnalyticsType.LINK);
};

export const fireUtagView = (payload, sep) => {
  const trackerPayload = transformEventPayload(payload, sep);
  utagAnalyticsBaseAttributes[UtagAnalyticsType.VIEW] = {
    tealium_event: 'ps_generic_view',
    page_name: document?.title,
  };

  sendAnalyticsPayload(trackerPayload, UtagAnalyticsType.VIEW);
};
